// extracted by mini-css-extract-plugin
module.exports = {"explain":"Explain_explain__3fylI","content":"Explain_content__2Xpjh","close":"Explain_close__psr-e"};